import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbAccordionConfig } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { LoadingData } from "select2";
import { CrudService } from "src/app/Services/crud.service";
import { LoadingService } from "src/app/Services/loading.service";
import { LogedInUserService } from "src/app/Services/loged-in-user.service";

@Component({
  selector: "app-translation",
  templateUrl: "./translation.component.html",
  standalone: false,
})
export class TranslationComponent implements OnInit {
  currentProject = {
    id: "",
    name: "",
    primaryLanguage: "",
    supportedLanguage: [],
  };
  activeTabId = "tooltip-tab-id";
  selectedVersion: string = "";
  selectedLanguage: string = "";
  selectedTransitOption: string = "lastTransit";
  selectedDate: Date | null = new Date();
  versionList = [];
  filteredLanguages = [];
  languageList = [];
  tooltipData = [];
  faqData = [];
  workflowData = [];
  userguideData = [];
  isLoading: boolean = false;
  loadingSub;
  enviornment = [];
  currentSelectedenviornment = "dev";
  constructor(
    private translateService: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private crudService: CrudService,
    private logedInUserService: LogedInUserService,
    private route: ActivatedRoute,
    config: NgbAccordionConfig,
    private router: Router,
    private sanitizer: DomSanitizer,
    private datePipe: DatePipe,
    private loadingService: LoadingService
  ) {
    this.getLanguages();
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
    this.enviornment = [
      { label: "Dev", value: "dev" },
      { label: "QA", value: "qa" },
      { label: "Prod", value: "prod" },
    ];
  }

  ngOnInit() {
    // this.isLoading = true;
    this.loadingService.show();
    this.route.params.subscribe((params) => {
      let projectId = params["pid"];
      this.activeTabId =
        params["tabId"] == "tooltip"
          ? "tooltip-tab-id"
          : params["tabId"] == "faq"
          ? "faq-tab-id"
          : params["tabId"] == "userguide"
          ? "user-guide-tab-id"
          : params["tabId"] == "workflow"
          ? "workflow-tab-id"
          : this.activeTabId;

      this.getProjectManagementData = this.getProjectManagementData.bind(this);

      this.getVersions(projectId);
      this.getLatestVersion(projectId);
      this.getProjectManagementData(projectId);
      this.getTooltipTranslationData =
        this.getTooltipTranslationData.bind(this);
      this.getWorkflowTranslationData =
        this.getWorkflowTranslationData.bind(this);
      this.getFaqTranslationData = this.getFaqTranslationData.bind(this);
      this.getUserGuideTranslationData =
        this.getUserGuideTranslationData.bind(this);

      setTimeout(() => {
        this.fetchAllTranslationData(projectId);
        this.getTooltipTranslationData(
          projectId,
          this.selectedLanguage,
          this.selectedVersion,
          this.selectedTransitOption,
          this.selectedDate
        );
        this.getWorkflowTranslationData(
          this.currentProject.id,
          this.selectedLanguage,
          this.selectedVersion,
          this.selectedTransitOption,
          this.selectedDate,
          this.currentSelectedenviornment
        );
        this.getFaqTranslationData(
          projectId,
          this.selectedLanguage,
          this.selectedVersion,
          this.selectedTransitOption,
          this.selectedDate
        );
        this.getUserGuideTranslationData(
          projectId,
          this.selectedLanguage,
          this.selectedVersion,
          this.selectedTransitOption,
          this.selectedDate
        );
      }, 1000);
    });
    this.loadingService.hide();
    this.loadingSub = this.loadingService.loading$.subscribe((val) => {
      this.isLoading = val;
    });
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  getVersions(projectId) {
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        self.versionList = response;
      },
      "Versions?filter[order]=created DESC&filter[where][projectManagementId]=" +
        projectId
    );
  }

  getLanguages() {
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        self.languageList = response;
      },
      "languages"
    );
  }

  getLanguageName(languageId) {
    if (this.languageList.length) {
      var langauge = this.languageList.find(function (val) {
        return val.id === languageId;
      });
      if (langauge) {
        return langauge.name;
      } else {
        return "English";
      }
    }
  }

  getLatestVersion(projectId) {
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        self.selectedVersion = response.id;
      },
      "Versions/findOne?filter[order]=created DESC&filter[where][projectManagementId]=" +
        projectId
    );
  }

  getProjectManagementData(projectId) {
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        self.currentProject = response;
        self.filteredLanguages = self.currentProject.supportedLanguage.filter(
          (lang) => lang.id !== self.currentProject.primaryLanguage
        );
        if (self.filteredLanguages.length > 0) {
          self.selectedLanguage = self.filteredLanguages[0].id;
        }
      },
      'projectManagements/findOne?filter={"where":{"id":"' + projectId + '"}}'
    );
  }

  onFilterChange() {
    if (this.selectedTransitOption == "lastTransit" && this.selectedDate) {
      this.selectedDate = new Date();
    }
    this.getTooltipTranslationData(
      this.currentProject.id,
      this.selectedLanguage,
      this.selectedVersion,
      this.selectedTransitOption,
      this.selectedDate
    );
    this.getWorkflowTranslationData(
      this.currentProject.id,
      this.selectedLanguage,
      this.selectedVersion,
      this.selectedTransitOption,
      this.selectedDate
    );
    this.getFaqTranslationData(
      this.currentProject.id,
      this.selectedLanguage,
      this.selectedVersion,
      this.selectedTransitOption,
      this.selectedDate
    );
    this.getUserGuideTranslationData(
      this.currentProject.id,
      this.selectedLanguage,
      this.selectedVersion,
      this.selectedTransitOption,
      this.selectedDate
    );
  }

  getTooltipTranslationData(
    projectId,
    languageId,
    projectVersion,
    transitOption,
    selectedDate?
  ) {
    this.loadingService.show();

    var query = `?projectId=${projectId}&languageId=${languageId}&projectVersion=${projectVersion}&transitOption=${transitOption}&publishStage=${this.currentSelectedenviornment}`;
    if (transitOption == "date") {
      query =
        query +
        `&selectedDate=${this.datePipe.transform(selectedDate, "yyyy-MM-dd")}`;
    }
    this.crudService.get(
      null,
      (response) => {
        // this.isLoading = false;
        if (response) {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            this.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
            this.loadingService.hide();
          } else {
            this.tooltipData = response;
            this.loadingService.hide();
          }
        }
      },
      "tooltips/getDataForTanslator" + query
    );
  }

  getWorkflowTranslationData(
    projectId,
    languageId,
    projectVersion,
    transitOption,
    selectedDate?,
    selectedEnv?
  ) {
    this.loadingService.show();
    var query = `?projectId=${projectId}&languageId=${languageId}&projectVersion=${projectVersion}&transitOption=${transitOption}&publishStage=${selectedEnv}`;
    if (transitOption == "date") {
      query =
        query +
        `&selectedDate=${this.datePipe.transform(selectedDate, "yyyy-MM-dd")}`;
    }
    this.crudService.get(
      null,
      (response) => {
        // this.isLoading = false;
        if (response) {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            this.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
          } else {
            this.workflowData = response;
            /* 
            console.log("current project", this.currentProject);
            console.log("workflowData", this.workflowData); */
            this.loadingService.hide();
          }
        }
      },
      "workflows/getDataForTanslator" + query
      // "workflows/getDataForTranslation" + query
    );
  }

  getFaqTranslationData(
    projectId,
    languageId,
    projectVersion,
    transitOption,
    selectedDate?
  ) {
    this.loadingService.show();

    var query = `?projectId=${projectId}&languageId=${languageId}&projectVersion=${projectVersion}&transitOption=${transitOption}&publishStage=${this.currentSelectedenviornment}`;
    if (transitOption == "date") {
      query =
        query +
        `&selectedDate=${this.datePipe.transform(selectedDate, "yyyy-MM-dd")}`;
    }

    console.log("get faq for translation", query);
    this.crudService.get(
      null,
      (response) => {
        if (response) {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            this.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
          } else {
            this.faqData = response;
            this.loadingService.hide();
          }
        }
      },
      // "faqs/getDataForTanslator" + query
      "faqs/getDataForTranslation" + query
    );
  }

  getUserGuideTranslationData(
    projectId,
    languageId,
    projectVersion,
    transitOption,
    selectedDate?
  ) {
    this.loadingService.show();
    var query = `?projectId=${projectId}&languageId=${languageId}&projectVersion=${projectVersion}&transitOption=${transitOption}&publishStage=${this.currentSelectedenviornment}`;
    if (transitOption == "date") {
      query =
        query +
        `&selectedDate=${this.datePipe.transform(selectedDate, "yyyy-MM-dd")}`;
    }
    this.crudService.get(
      null,
      (response) => {
        // this.isLoading = false;
        if (response) {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            this.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
          } else {
            this.userguideData = response;
            this.userguideData = this.userguideData.map((item) => {
              const matchedLang = item.supportedLanguages?.find(
                (lang) => lang.id === this.selectedLanguage
              );

              this.loadingService.hide();
              return {
                ...item,
                supportedLanguages: matchedLang || null, // or [] if you prefer empty array
              };
            });
          }
        }
      },
      "userguides/getDataForTanslation" + query
      // "userguides/getDataForTanslator" + query
    );
  }

  tabChange(tabName) {}
  getHintTextByLanguage(item: any, languageId: string): string {
    const match = item?.supportedLanguages?.find(
      (lang) => lang.id === languageId
    );
    if (!match) {
      // console.warn("Language not found for ID:", languageId);
      return "";
    }

    return match.hintText || "";
  }
  onEnviornmentChange(val) {
    this.currentSelectedenviornment = val;

    // Call your data fetching methods again
    const projectId = this.currentProject?.id; // Make sure currentProject is already set
    if (projectId) {
      this.fetchAllTranslationData(projectId);
    }
  }

  private fetchAllTranslationData(projectId: string) {
    this.getTooltipTranslationData(
      projectId,
      this.selectedLanguage,
      this.selectedVersion,
      this.selectedTransitOption,
      this.selectedDate
    );

    this.getWorkflowTranslationData(
      projectId,
      this.selectedLanguage,
      this.selectedVersion,
      this.selectedTransitOption,
      this.selectedDate
    );

    this.getFaqTranslationData(
      projectId,
      this.selectedLanguage,
      this.selectedVersion,
      this.selectedTransitOption,
      this.selectedDate
    );

    this.getUserGuideTranslationData(
      projectId,
      this.selectedLanguage,
      this.selectedVersion,
      this.selectedTransitOption,
      this.selectedDate
    );
  }
}
